// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { Fan as RawFan } from "lucide-react";
export const Fan = /* @__PURE__ */ createIcon(RawFan, "Fan", 2);
